module.exports = __webpack_public_path__ + "static/media/img-moduleC1.aa9175dd.png";